// @flow
import React from 'react';
import Button from 'Components/Button';
import GalleryModal from './Modal';
import AssetModel from 'Stores/AssetModel';
import Image from './image';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

type Props = {
  images: Array<AssetModel>,
  fullsize?: boolean,
  showThumbnails?: boolean,
  btnLabel?: string,
};

type State = {
  isOpen: boolean,
  selectedItem: number,
};

export default class Gallery extends React.Component<Props, State> {
  static defaultProps = {
    showThumbnails: true,
    btnLabel: 'Kurzanleitung ansehen',
  };

  state = {
    isOpen: false,
    selectedItem: 0,
  };

  onOpen = (index: number = 0) => {
    this.setState({ selectedItem: index, isOpen: true });
  };

  onClose = () => {
    this.setState({ isOpen: false });
  };

  renderThumbnails = (rows: Array<any>, imagesLength: number) => {
    return rows.map((items, i) => (
      <div key={'row' + i} className={styles.row}>
        <div className={styles.rowContainer}>
          {items.map((item) => (
            <div className={styles.gridEl} key={item.id}>
              <Image
                onClick={this.onOpen}
                previewUrl={item.src}
                focus={item.focus}
                index={item.index}
                imagesLength={imagesLength}
              />
            </div>
          ))}
        </div>
      </div>
    ));
  };

  render() {
    const { images, fullsize, showThumbnails, btnLabel } = this.props;

    const imagesLength = images.length;
    const gridClass = cx('root', 'grid', {
      fullsize,
      more6: imagesLength > 6,
      more9: imagesLength > 9,
    });

    // creates rows consisting of three images
    const rows = images.reduce((rows, key, index) => {
      key.index = index;

      if (index % 3 === 0) {
        rows.push([key]);
      } else {
        rows[rows.length - 1].push(key);
      }
      return rows;
    }, []);

    return (
      <div className={showThumbnails ? gridClass : styles.root}>
        {showThumbnails && this.renderThumbnails(rows, imagesLength)}
        {!showThumbnails && (
          <Button label={btnLabel} type="tertiary" icon="picture" onClick={this.onOpen} />
        )}
        <GalleryModal
          onClose={this.onClose}
          isOpen={this.state.isOpen}
          selectedItem={this.state.selectedItem}
        >
          {images.map((image, index) => {
            return (
              <Image
                key={image.id}
                url={image.src}
                title={image.title}
                description={image.description}
                index={index}
                imagesLength={imagesLength}
                detailView
              />
            );
          })}
        </GalleryModal>
      </div>
    );
  }
}
